import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import { Loader2, CheckCircle2, Mail } from 'lucide-react';
import api from '../lib/api';

export default function WorkshopGracias() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState('checking'); // checking | paid | failed | timeout
  const [email, setEmail] = useState('');
  const [tier, setTier] = useState('');

  useEffect(() => {
    if (!sessionId) { setStatus('failed'); return; }
    let cancelled = false;
    let tries = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        if (r.data.payment_status === 'paid') {
          setStatus('paid');
          setEmail(r.data.email || '');
          setTier(r.data.tier_name || '');
          return;
        }
        if (r.data.payment_status === 'failed' || r.data.payment_status === 'expired') {
          setStatus('failed');
          return;
        }
      } catch (_) {}
      tries += 1;
      if (tries >= 20) { setStatus('timeout'); return; }
      setTimeout(poll, 1500);
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#FDFCFA] flex items-center justify-center px-6 py-24">
      <div className="max-w-lg w-full text-center">
        {status === 'checking' && (
          <>
            <Loader2 className="w-10 h-10 text-[#c9a227] animate-spin mx-auto mb-6" />
            <h1 className="font-heading text-2xl text-[#2a2d24] mb-3">Confirmando tu pago…</h1>
            <p className="text-sm text-[#5a5d53]">Esto tarda unos segundos. No cierres esta ventana.</p>
          </>
        )}
        {status === 'paid' && (
          <>
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#faf3df] border border-[#c9a227]/40 mb-6">
              <CheckCircle2 className="w-8 h-8 text-[#c9a227]" strokeWidth={1.5} />
            </div>
            <h1 className="font-heading text-3xl text-[#2a2d24] mb-3">¡Tu plaza está reservada!</h1>
            <p className="text-base text-[#3a3d33] leading-relaxed mb-6">
              Gracias por confiar. Tu plaza en el taller {tier ? `(${tier})` : ''} está guardada.
            </p>
            <div className="bg-white/70 border border-[#e8e4da] rounded-2xl p-6 text-left mb-6">
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#c9a227] mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                <div>
                  <p className="text-sm text-[#2a2d24] font-medium mb-1">Revisa tu email</p>
                  <p className="text-sm text-[#5a5d53] leading-relaxed">
                    Te hemos enviado a <strong>{email || 'tu correo'}</strong> un enlace mágico para entrar a <em>Mi Camino</em>.
                    Si no lo ves, mira en promociones o spam.
                  </p>
                </div>
              </div>
            </div>
            <Link to="/mi-camino" className="text-sm text-[#8a7428] hover:underline">
              O prueba a entrar directamente a Mi Camino →
            </Link>
          </>
        )}
        {status === 'failed' && (
          <>
            <h1 className="font-heading text-2xl text-[#2a2d24] mb-3">No pudimos confirmar el pago</h1>
            <p className="text-sm text-[#5a5d53] mb-6">Si el cobro se ha hecho, escríbenos y lo resolvemos en 24h.</p>
            <Link to={`/masterclass/${slug}`} className="text-sm text-[#8a7428] hover:underline">Volver al taller</Link>
          </>
        )}
        {status === 'timeout' && (
          <>
            <h1 className="font-heading text-2xl text-[#2a2d24] mb-3">Tu pago está en proceso</h1>
            <p className="text-sm text-[#5a5d53] mb-6">Recibirás el email con tu enlace de acceso en unos minutos.</p>
            <Link to="/" className="text-sm text-[#8a7428] hover:underline">Ir al inicio</Link>
          </>
        )}
      </div>
    </div>
  );
}
